import { useState } from "react";
import { ZONES } from "@/data/portfolio";

export default function ZoneDiagram() {
  const [active, setActive] = useState(0);
  const zone = ZONES[active];

  return (
    <div data-testid="zone-diagram" className="border border-[#e5e0d8] bg-white">
      <div className="grid grid-cols-4">
        {ZONES.map((z, i) => (
          <button
            key={z.rating}
            data-testid={`zone-tab-${z.rating.toLowerCase()}`}
            onClick={() => setActive(i)}
            className={`relative p-4 sm:p-6 text-left border-r last:border-r-0 border-[#e5e0d8] transition-colors ${
              active === i
                ? "bg-[#14352a] text-[#faf8f5]"
                : "hover:bg-[#f2ece4] text-[#14352a]"
            }`}
          >
            <div
              className={`font-mono-label text-[9px] sm:text-[10px] ${
                active === i ? "text-[#9a7218]" : "text-[#86928a]"
              }`}
            >
              Zone 0{i + 1}
            </div>
            <div className="mt-2 font-display text-base sm:text-lg leading-tight">
              {z.rating}
            </div>
            <div
              className={`mt-1 text-[10px] sm:text-xs leading-snug ${
                active === i ? "text-[#faf8f5]/80" : "text-[#55625b]"
              }`}
            >
              {z.name}
            </div>
          </button>
        ))}
      </div>
      <div className="p-6 sm:p-10 border-t border-[#e5e0d8]">
        <div className="font-mono-label text-[10px] text-[#9a7218]">
          {zone.rating} · {zone.name}
        </div>
        <p className="mt-4 font-display text-xl sm:text-2xl leading-snug text-[#14352a] max-w-3xl">
          {zone.body}
        </p>
      </div>
    </div>
  );
}
